import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Button } from 'react-bootstrap';
import getCroppedImg from '../../utils/cropUtils';

export default function ImageCropper({ imageSrc, onCropDone, onCancel, aspect }) {
  const[crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  },[]);

  const handleSave = async () => {
    try {
      const croppedImageFile = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropDone(croppedImageFile);
    } catch (e) {
      console.error("Ошибка при обрезке", e);
      alert("Не удалось обработать изображение. Попробуйте выбрать другой файл или изменить область обрезки.");
    }
  };

  return (
    <div className="d-flex flex-column" style={{ height: '50vh', minHeight: '400px' }}>
      <div className="position-relative flex-grow-1 bg-dark rounded-3 overflow-hidden mb-3">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspect} /* Пропорции (4:3 для карточек, 16:9 для баннеров) */
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="w-50 d-flex align-items-center">
          <i className="bi bi-zoom-out me-2 text-muted"></i>
          <input 
            type="range" 
            value={zoom} 
            min={1} 
            max={3} 
            step={0.1} 
            onChange={(e) => setZoom(e.target.value)} 
            className="form-range"
          />
          <i className="bi bi-zoom-in ms-2 text-muted"></i>
        </div>
        <div>
          <Button variant="light" onClick={onCancel} className="me-2">Отмена</Button>
          <Button className="btn-corp" onClick={handleSave}>Применить</Button>
        </div>
      </div>
    </div>
  );
}
